// Add your custom JS here.
let throttleTimer, customerLoaded, customerInfo, customerEmail, customerId, loyaltyVal, pointsText, customerOrders;
let pageSize = 5;
let page = 1;
// The header heights and promo-banner probe that used to live here are gone
// with the inline style writes that used them. Those pixel values are owned by
// $header-offset / $header-offset-mobile / $promo-banner-height in
// src/sass/theme/_child_theme_variables.scss and reach the page as
// --header-offset, so there is nothing left for JS to keep in sync.
const throttle = (callback, time) => {
    if (throttleTimer) return;
    throttleTimer = true;
    setTimeout(() => {
    callback();
    throttleTimer = false;
    }, time);
};
const scrollFunction = () => {
  // Layout is CSS now. This writes no styles - it only reports scroll state as
  // a class on <body>, so it cannot fight the header grid. Everything it used
  // to set inline lives in the "SCROLL-SHRINK" block in src/sass/theme/
  // _general.scss and the header grid in _header.scss.
  //
  // The 80 / 40 thresholds keep the original hysteresis: shrink past 80px,
  // restore below 40px, so the header cannot flap on small scroll jitter.
  const y = document.documentElement.scrollTop;
  if (y > 80) {
    document.body.classList.add('is-scrolled');
  } else if (y < 40) {
    document.body.classList.remove('is-scrolled');
  }
};
const displayNoOrders = () => {
  jQuery("#order-info #previous-orders").html("<h3>Nothing here… yet.</h3>");
};
const displayOrderInfo = customerOrders => {
  console.log("customerOrders:", customerOrders);
  const orderContainer = jQuery('#order-details');
  orderContainer.empty();
  jQuery.each(customerOrders, (index, order) => {
	const count = index + 1;
	const linkDiv = jQuery('<div>').addClass('order-date').attr('id', `order-date-${count}`);
	const orderLink = jQuery('<a>').attr({
	  href: 'javascript:void(0);',
	  'aria-expanded': 'false',
	  'aria-controls': `order-info-${count}`
	}).addClass('order-link').text(`Date: ${order.order_date}`);
	const orderDiv = jQuery('<div>').addClass('order-info').attr({
	  id: `order-info-${count}`,
	  role: 'region',
	  'aria-hidden': 'true'
	}).html('<strong>Items purchased:</strong><br>');
	jQuery.each(order.items, (i, item) => {
	  const price = parseFloat(item.price) || 0;
	  const discount = parseFloat(item.discount) || 0;
	  const quantity = parseInt(item.quantity) || 1;
	  const subtotal = parseFloat(item.subtotal) || price * quantity - discount;
	  const exciseTax = parseFloat(item.excise_tax) || 0;
	  const salesTax = parseFloat(item.sales_tax) || 0;
	  let itemHtml = '';
	  if (item.category) itemHtml += `(${item.category})<br>`;
	  if (item.brand) itemHtml += `<b>${item.brand}</b><br>`;
	  if (item.product_name) itemHtml += `${item.product_name}<br>`;
	  if (quantity) itemHtml += `Quantity: ${quantity}<br>`;
	  if (price) itemHtml += `Price: ${price.toFixed(2)}<br>`;
	  if (discount > 0) itemHtml += `Discount: ${discount.toFixed(2)}<br>`;
	  if (subtotal) itemHtml += `Subtotal: ${subtotal.toFixed(2)}<br>`;
	  if (exciseTax > 0) itemHtml += `Item excise tax: ${exciseTax.toFixed(2)}<br>`;
	  if (salesTax > 0) itemHtml += `Item sales tax: ${salesTax.toFixed(2)}<br>`;
	  orderDiv.append(itemHtml);
	});
	const subtotal = parseFloat(order.subtotal) || 0;
	const discount = parseFloat(order.discount_total) || 0;
	const excise_tax_total = parseFloat(order.excise_tax_total) || 0;
	const sales_tax_total = parseFloat(order.sales_tax_total) || 0;
	const total = subtotal - discount + excise_tax_total + sales_tax_total;
	orderDiv.append('<hr>');
	if (subtotal) orderDiv.append(`Subtotal: ${subtotal.toFixed(2)}<br>`);
	if (discount > 0) orderDiv.append(`Discount: ${discount.toFixed(2)}<br>`);
	if (excise_tax_total > 0) orderDiv.append(`Excise tax: ${excise_tax_total.toFixed(2)}<br>`);
	if (sales_tax_total > 0) orderDiv.append(`Sales tax: ${sales_tax_total.toFixed(2)}<br>`);
	orderDiv.append(`Total: ${total.toFixed(2)}<br>&nbsp;`);
	linkDiv.append(orderLink, orderDiv);
	orderContainer.append(linkDiv);
  });

  // Delegate click handler for all order links
  orderContainer.off('click', '.order-link').on('click', '.order-link', function () {
	const $this = jQuery(this);
	const targetId = $this.attr('aria-controls');
	const isExpanded = $this.attr('aria-expanded') === 'true';

	// Collapse all orders
	jQuery('.order-link').attr('aria-expanded', 'false');
	jQuery('.order-info').attr('aria-hidden', 'true').hide();

	// Expand the clicked order
	if (!isExpanded) {
	  $this.attr('aria-expanded', 'true');
	  jQuery(`#${targetId}`).attr('aria-hidden', 'false').show();
	}
  });

  // Collapse any open order info when clicking outside
  jQuery(document).off('click.orderInfo').on('click.orderInfo', function (event) {
	const $target = jQuery(event.target);
	if (!$target.closest('.order-link').length && !$target.closest('.order-info').length) {
	  jQuery('.order-link').attr('aria-expanded', 'false');
	  jQuery('.order-info').attr('aria-hidden', 'true').hide();
	}
  });
};
const getIdAndLoyalty = customerEmail => {
  if (!customerEmail) {
	console.log("No customer email provided.");
	return;
  }
  console.log("Fetching customer info for:", customerEmail);
  jQuery.ajax({
	method: "POST",
	url: `${THEME_BASE}/getCustomerIdAndLoyalty.php`,
	data: {
	  customerEmail
	},
	success: function (response) {
	  let customerInfo;
	  try {
		customerInfo = typeof response === "string" ? JSON.parse(response) : response;
	  } catch (err) {
		console.error("Error parsing customer info:", err, response);
		return;
	  }
	  const customerIds = customerInfo.ids || [];
	  const isLoyal = customerInfo.isLoyal || false;
	  const loyaltyPoints = customerInfo.loyaltyPoints || 0;

	  // Show loyalty section
	  jQuery("#loyalty-loading").fadeOut(200, () => jQuery("#loyalty").fadeIn(200));
	  let pointsText = "";
	  if (isLoyal) {
		jQuery("#loyalty .um-field-checkbox").addClass("active");
		const loyaltyVal = (loyaltyPoints * 0.05).toFixed(2);
		pointsText = `<b>points: ${loyaltyPoints}</b> ($${loyaltyVal})`;
	  } else {
		jQuery("#loyalty .um-field-checkbox .um-icon-android-checkbox-outline").removeClass("um-icon-android-checkbox-outline").addClass("um-icon-android-checkbox-outline-blank");
		pointsText = '<a href="mailto:contact@sashiesdispensary.com?subject=Loyalty%20Program">Contact us to join loyalty program</a>';
	  }
	  jQuery("#loyalty > #points").html(pointsText);

	  // Reset orders each time we look up a new customer
	  allCustomerOrders = [];
	  if (customerIds.length > 0) {
		console.log("Fetching orders for IDs:", customerIds);
		fetchAllOrders(customerIds); // <-- single call handles all IDs now
	  } else {
		displayNoOrders();
		console.log("No customer IDs found.");
	  }
	},
	error: function (err) {
	  console.error("Error retrieving customer info:", err);
	}
  });
};
const fetchAllOrders = customerIds => {
  console.log("Fetching orders for IDs:", customerIds);
  jQuery.ajax({
	method: "POST",
	url: `${THEME_BASE}/getCustomerOrders.php`,
	traditional: true,
	// ensure PHP sees the array correctly
	data: {
	  "customerIds[]": customerIds,
	  // explicitly send as array
	  pageSize: pageSize,
	  page: page
	},
	success: function (response) {
	  // jQuery may auto-parse JSON; if not, parse
	  const orders = Array.isArray(response) ? response : JSON.parse(response);
	  console.log("Orders received:", orders);
	  allCustomerOrders = orders.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
	  console.log("calling displayOrderInfo");
	  if (!allCustomerOrders || allCustomerOrders.length === 0) {
		displayNoOrders();
	  } else {
		displayOrderInfo(allCustomerOrders);
	  }
	},
	error: function (err) {
	  console.error("Error fetching customer orders:", err);
	}
  });
};
const menuSelection = () => {
  let navClasses = document.getElementById('menu-item-66').className.split(/\s+/);
  if (navClasses.includes("current_page_parent")) {
	jQuery("#menu-item-66").removeClass("current_page_parent");
	jQuery("#menu-item-410").addClass("current_page_parent");
  }
  jQuery("#rmp-menu-item-410").addClass("current-menu-item");
  jQuery("#rmp-menu-item-410").addClass("rmp-menu-current-item");
};
const removeSlashes = currentPage => {
  let pathname = currentPage.replaceAll("/", "");
  return pathname;
};
jQuery(document).ready(function () {
  let parentPath = window.location.pathname.split('/')[1];
  let parentPath2 = window.location.pathname.split('/')[2];
  if (parentPath == 'events' || parentPath2 == 'events') {
	menuSelection();
  }
  let currentPage = removeSlashes(window.location.pathname);
  if (currentPage == 'account') {
	location.href = `${ORIGIN}/account/general/`;
  }
  /* if (currentPage == 'account' || currentPage == 'accountgeneral' || currentPage == 'accountpassword' || currentPage == 'accountprivacy' || currentPage == 'accountgeneral' || currentPage == 'accountdelete') { */
  if (currentPage.indexOf('account') !== -1) {
	jQuery(".logout").click(function () {
	  location.href = `${ORIGIN}/logout/`;
	});
	customerEmail = jQuery("#customer-email").data("email");
	console.log("customerEmail:", customerEmail);
	getIdAndLoyalty(customerEmail);
  }
});
window.addEventListener("scroll", () => {
  throttle(scrollFunction, 330);
});
scrollFunction();

// ---------------------------------------------------------------------------
// Promo banner dismiss
// The "already dismissed" case is handled synchronously by the inline
// script in template-parts/promo-banner.php, before this (footer) script
// even loads. This just wires up the click-to-dismiss.
// ---------------------------------------------------------------------------
(() => {
  const banner = document.getElementById('promo-banner');
  const dismissBtn = banner ? banner.querySelector('.promo-banner__dismiss') : null;
  if (!banner || !dismissBtn) return;
  dismissBtn.addEventListener('click', () => {
	try {
	  window.localStorage.setItem('sashiesPromoDismissed', banner.getAttribute('data-promo-key'));
	} catch (e) {
	  // localStorage unavailable (private mode, quota) - dismissal just won't persist across reloads.
	}
	banner.style.display = 'none';
	document.body.classList.remove('has-promo-banner');
	document.getElementById('masthead').style.marginTop = '';
	const siteMain = document.getElementsByClassName('site-main')[0];
	if (siteMain) {
	  siteMain.style.paddingTop = '';
	}
  });
})();

// ---------------------------------------------------------------------------
// Sashies Slides - "See all sizes" badge
// Anchored to the Merch tag inside Jane Boost's shadow root
// ---------------------------------------------------------------------------
(function () {
  const TRIGGER    = 'sashies-sashies-slides';
  const POST_URL   = 'https://www.sashiesdispensary.com/new-drops-sashies-slides/'; // TODO: update
  const BADGE_ID   = 'sashies-slides-badge';
  const TAG_SEL    = '._tag_182vf_1';
  let mutationObserver = null;
  let resizeObserver   = null;

  function getShadowRoot() {
    const host = document.getElementById('shadow-host');
    return host ? host.shadowRoot : null;
  }

  function positionBadge(badge) {
    const shadowRoot = getShadowRoot();
    if (!shadowRoot) return;
    const tagEl = shadowRoot.querySelector(TAG_SEL);
    if (!tagEl) return;
    const rect   = tagEl.getBoundingClientRect();
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    badge.style.top  = (rect.top  + scrollY + rect.height / 2 - 13) + 'px';
    badge.style.left = (rect.right + scrollX + 8) + 'px';
  }

  function injectBadge() {
    if (document.getElementById(BADGE_ID)) return true;
    const shadowRoot = getShadowRoot();
    if (!shadowRoot) return false;
    const tagEl = shadowRoot.querySelector(TAG_SEL);
    if (!tagEl) return false;

    const badge = document.createElement('a');
    badge.id       = BADGE_ID;
    badge.href     = POST_URL;
    badge.target   = '_self';
    badge.rel      = 'noopener';
    badge.textContent = '👟 See all sizes →';
    badge.style.cssText = `
      position: absolute;
      z-index: 9;
      background: #1b3e2f;
      color: #fff2db;
      font-family: 'Kanit-Regular', sans-serif;
      font-weight: 400;
      font-size: 18px;
      padding: 4px 14px;
      border-radius: 999px;
      text-decoration: none;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      cursor: pointer;
      white-space: nowrap;
    `;

    document.body.appendChild(badge);
    requestAnimationFrame(() => requestAnimationFrame(() => positionBadge(badge)));

    resizeObserver = new ResizeObserver(() => positionBadge(badge));
    resizeObserver.observe(document.body);

    return true;
  }

  function startObserving() {
    if (injectBadge()) return;
    if (mutationObserver) return;

    // Try observing the shadow root directly if it exists
    const shadowRoot = getShadowRoot();
    const observationTarget = shadowRoot || document.body;

    mutationObserver = new MutationObserver(() => {
      const shadowRoot = getShadowRoot();
      if (!shadowRoot) return;
      const tagEl = shadowRoot.querySelector(TAG_SEL);
      if (tagEl) {
        mutationObserver.disconnect();
        mutationObserver = null;
        requestAnimationFrame(() => requestAnimationFrame(() => injectBadge()));
      }
    });
    mutationObserver.observe(observationTarget, { childList: true, subtree: true });
  }

  function removeBadge() {
    const existing = document.getElementById(BADGE_ID);
    if (existing) existing.remove();
    if (mutationObserver) { mutationObserver.disconnect(); mutationObserver = null; }
    if (resizeObserver)   { resizeObserver.disconnect();   resizeObserver   = null; }
  }

  function checkURL() {
    if (window.location.href.includes(TRIGGER)) {
      startObserving();
    } else {
      removeBadge();
    }
  }

  const _pushState = history.pushState.bind(history);
  history.pushState = function (...args) {
    _pushState(...args);
    checkURL();
  };
  window.addEventListener('popstate', checkURL);

  checkURL();
})();